import { createContext, useContext } from 'react';

// ==============================================
// TYPES
// ==============================================

export type Theme = 'light' | 'dark' | 'system';

export interface ThemeContextType {
  /** Tema actual aplicado ('light' | 'dark') */
  theme: Exclude<Theme, 'system'>;
  /** Configuración del usuario ('light' | 'dark' | 'system') */
  themeMode: Theme;
  /** Función para cambiar el tema */
  setTheme: (theme: Theme) => void;
  /** Toggle entre light y dark */
  toggleTheme: () => void;
  /** Si está siguiendo la preferencia del sistema */
  isSystemTheme: boolean;
}

// ==============================================
// CONTEXT
// ==============================================

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

// ==============================================
// CONSTANTS
// ==============================================

export const THEME_STORAGE_KEY = 'kairos-theme-preference';

// ==============================================
// HOOK
// ==============================================

/**
 * Hook para usar el contexto de tema
 */
export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  
  if (context === undefined) {
    throw new Error('useTheme debe ser usado dentro de un ThemeProvider');
  }
  
  return context;
}; 